module.exports = firebase["auth"];